// 选住 优惠券
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { RESERVATION_SCENE } from '@/config/constant';
import XZCouponList from '@/components/SelectDiscountCoupon/component/XuanzhuCouponList';
import { getOptionalManualCouponList, saveData } from '@/redux/actions/guest';

// 手工券使用用途
const XZSceneMap = {
  [RESERVATION_SCENE.NewReserve]: '新预订',
  [RESERVATION_SCENE.ExtendReserve]: '追加预订',
  [RESERVATION_SCENE.ReserveExchange]: '预订换排房',
  [RESERVATION_SCENE.ReserveModify]: '预订修改',
  [RESERVATION_SCENE.NewCheckIn]: '新入住',
  [RESERVATION_SCENE.ExtendCheckIn]: '追加入住',
  [RESERVATION_SCENE.ReserveToNewCheckIn]: '预订转入住',
  [RESERVATION_SCENE.ReserveToExtendCheckIn]: '预订转追加入住',
  [RESERVATION_SCENE.CheckInExchange]: '入住换排房',
  [RESERVATION_SCENE.CheckInModify]: '入住修改',
  [RESERVATION_SCENE.Renewal]: '续住',
};

const Index = (props) => {
  const {
    fnGetOptionalManualCouponList,
    fnSaveData,
    optionalXuanzhuCouponListLoading,
    optionalXuanzhuCouponList,
    wyuid,
    sceneType,
    onListUpdate,
  } = props;

  const onUpdateCoupon = (index, params) => {
    const list = [...optionalXuanzhuCouponList];
    if (list[index]) {
      list[index] = { ...list[index], ...params };
    }
    fnSaveData({
      optionalXuanzhuCouponList: list,
    });
  };

  useEffect(() => {
    fnGetOptionalManualCouponList({ wyuid });
  }, []);

  useEffect(() => {
    onListUpdate(optionalXuanzhuCouponList || []);
  }, [optionalXuanzhuCouponList]);

  return (
    <XZCouponList
      xuanzhuCouponListLoading={optionalXuanzhuCouponListLoading}
      xuanzhuCouponList={optionalXuanzhuCouponList}
      remark={XZSceneMap[sceneType]}
      onUpdateCoupon={onUpdateCoupon}
    />
  );
};

const mapStateToProps = (state) => {
  const { optionalXuanzhuCouponListLoading, optionalXuanzhuCouponList } = state.guest || {};
  return {
    optionalXuanzhuCouponListLoading,
    optionalXuanzhuCouponList,
  };
};

const mapDispatchToProps = {
  fnGetOptionalManualCouponList: getOptionalManualCouponList,
  fnSaveData: saveData,
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Index));
